module.exports = __webpack_public_path__ + "img/808fe4e2b8a803ac20b92ec43cfc7922.8801358e.png";